class DisposalSiteService {
    axiosInstance;
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    wayste = {
        fetch: async (id) => {
            const response = await this.axiosInstance.mainInstance.get(`/disposal-site/${id}`);
            return response.data;
        },
        query: async () => {
            const response = await this.axiosInstance.mainInstance.get(`/disposal-site`);
            return response.data;
        },
        create: async (input) => {
            const response = await this.axiosInstance.mainInstance.post(`/disposal-site`, input);
            return response.data;
        },
        update: async (id, input) => {
            const response = await this.axiosInstance.mainInstance.put(`/disposal-site/${id}`, input);
            return response.data;
        },
        delete: async (id) => {
            const response = await this.axiosInstance.mainInstance.delete(`/disposal-site/${id}`);
            return response.data;
        },
    };
}
export default DisposalSiteService;
//# sourceMappingURL=DisposalSite.service.js.map